// extracted by mini-css-extract-plugin
export var orderDetails = "_pr-2";
export var orderImage = "_pr-1";
export var orderMeta = "_pr-3";
export var orderSummary = "_pr-0";
export var rightArrow = "_pr-4";